import React from 'react';
import getStyles from './WatermarkStyle';

export default () => {
    const classes = getStyles();

    return <div className={classes.watermark}/>;
};
